import { Link } from 'react-router-dom';
import JuntsButton from 'modules/website/shared/components/JuntsButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MapaCatalunya from 'assets/svg/MapaCatalunya';
import { Fade } from 'react-awesome-reveal';
import './BannerTerritori.scss';

function BannerTerritori() {
  return (
    <div className="bannerterritori__container">
      <div className="bannerterritori__wrap">
        <div className="bannerterritori__image">
          <MapaCatalunya />
        </div>
        <Fade triggerOnce delay={200}>
          <div className="bannerterritori__content">
            <h2>
              Junts,
              <br />a Catalunya
            </h2>
            <div className="bannerterritori__button">
              <Link to="/territori">
                <JuntsButton>
                  Coneix el territori <ArrowForwardIcon />
                </JuntsButton>
              </Link>
            </div>
          </div>
        </Fade>
      </div>

      <div className="line" />
    </div>
  );
}

export default BannerTerritori;
